import { render, staticRenderFns } from "./MobShareholderSummary.vue?vue&type=template&id=35d85bb2&scoped=true"
import script from "./MobShareholderSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./MobShareholderSummary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobShareholderSummary.vue?vue&type=style&index=0&id=35d85bb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d85bb2",
  null
  
)

export default component.exports